<template>
    <v-dialog v-model="dialog" max-width="600">
        <Loader ref="Loader"></Loader>
        <SuccessModal ref="SuccessModal"></SuccessModal>

        <v-card>
            <v-card-title>
                Allocate Ops Manager
            </v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <v-combobox label="Select customer" v-model="AllocationForm.CustomerID" :rules="fieldRules"
                        :items="customerItems" item-text="Name" item-value="ID"
                        @change="GetCustomerVenues"></v-combobox>
                    <v-combobox label="Select venue" v-model="AllocationForm.CustomerVenueID" :rules="fieldRules"
                        :items="venues" item-text="Name" item-value="ID" :disabled="venues.length == 0"
                        @change="GetSystemUsers">
                    </v-combobox>
                    <v-combobox v-model="AllocationForm.SystemUserID" label="Select ops-manager" :rules="fieldRules"
                        :items="systemUsers" :item-text="text" item-value="ID"
                        :disabled="AllocationForm.CustomerVenueID == null">
                    </v-combobox>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="SubmitAllocation()"
                            v-if="HasAccess('OPS_MANAGER_ALLOCATION_MANAGEMENT', 'CREATE')">Allocate
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ["customerItems"],
    data() {
        return {
            dialog: false,
            fieldRules: [v => !!v || "Field is required"],
            AllocationForm: {
                CustomerID: null,
                CustomerVenueID: null,
                SystemUserID: null,
            },
            day: null,
            systemUsers: [],
            venues: []
        }
    },
    methods: {
        text: item => item.Title + ' ' + item.FirstName + ' ' + item.LastName,
        GetSystemUsers() {
            let self = this;

            var customerID = self.AllocationForm.CustomerID.ID;
            self.get(`SystemUser/GetOpsManagers/CustomerID?customerID=${customerID}`).then(
                r => {
                    self.systemUsers = r.data;
                })
        },
        GetCustomerVenues() {
            let self = this;

            self.AllocationForm.CustomerVenueID = null;
            self.AllocationForm.SystemUserID = null;

            self.$nextTick(() => {
                var customerID = self.AllocationForm.CustomerID.ID;
                self.get(`CustomerVenue/CustomerID?customerID=${customerID}`).then(
                    r => {
                        self.venues = r.data;
                    })

            })
        },
        show(day) {
            this.dialog = true;
            this.day = day;
        },
        hide() {
            this.$refs.form.reset();
            this.$refs.SuccessModal.hide();
            this.dialog = true;
        },
        SubmitAllocation() {
            let self = this;

            let request = {
                AllocatedDate: self.day.date,
                CustomerID: self.AllocationForm.CustomerID.ID,
                CustomerVenueID: self.AllocationForm.CustomerVenueID.ID,
                SystemUserID: self.AllocationForm.SystemUserID.ID,
                IsAdHoc: false
            }

            self.post(`OpsManagerAssessmentAllocation/Allocate`, request).then(r => {
                self.$refs.SuccessModal.show(); // success modal
                self.$refs.SuccessModal.setText("Ops Manager has been allocated!");

                setTimeout(function () {
                    //self.GetAlloctions();
                    self.$refs.form.reset();
                    self.$refs.SuccessModal.hide();

                    self.$emit(`allocated`, r.data);
                    self.dialog = false;
                }, 1000);
            })
        },
    }
}
</script>